import { useContext } from "react";
import { errorAlertContextV2 } from "./errorAlertContextV2";

export function useErrorAlertV2() {
  const context = useContext(errorAlertContextV2);
  if (!context) {
    throw new Error("useErrorAlert must be used within a ErrorAlertProviderV2");
  }
  return context;
}
